export default __webpack_public_path__ + "static/media/logos.a490f1d5.webp";